/* eslint-disable no-use-before-define */
import React, { useEffect } from 'react';
import Chip from '@material-ui/core/Chip';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';



const filter = createFilterOptions();



export default function Tags(props) {
    const [value, setValue] = React.useState([]);
    const [selections, setSelections] = React.useState([]);

    const [open, toggleOpen] = React.useState(false);
    const [dialogValue, setDialogValue] = React.useState({
        title: '',
      });


  const handleClose = () => {
    setDialogValue({
      title: '',
    });

    toggleOpen(false);
  };

 

  const handleSubmit = (event) => {
    event.preventDefault();
    let val = value;

    val.push({
        title: dialogValue.title,
      })

    props.handleselect(val)
    handleClose();
  };



  useEffect(() => {
    setSelections(props.selections)
}, [props.selections])


useEffect(() => {
 setValue(props.value)
}, [props.value])

  return (
    <>
   
      <Autocomplete
        multiple
        value={value}
        size="small"
        onChange={(event, newValue) => {
            let vals = newValue[newValue.length - 1];
            if (typeof vals === 'string') {
              // timeout to avoid instant validation of the dialog's form.
              setTimeout(() => {
                toggleOpen(true);
                setDialogValue({
                  title: vals,
                });
              });
            } else if (vals && vals.inputValue) {
              toggleOpen(true);
              setDialogValue({
                title: vals.inputValue,
              });
            } else {
              setValue(newValue);
              props.handleselect(newValue)

            }
          }}

        id={`multi-${props.name}`}
        filterOptions={(options, params) => {
            const filtered = filter(options, params);

            if (params.inputValue !== '') {
              filtered.push({
                inputValue: params.inputValue,
                title: `Add "${params.inputValue}"`,
              });
            }
            return filtered;
          }}
        options={selections}
        getOptionLabel={(option) => option.title}
        filterSelectedOptions

        renderInput={(params) => (
          <TextField
            {...params}
            {...props}
          />
        )}
      />

<Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
        <form onSubmit={handleSubmit}>
          <DialogTitle id="form-dialog-title">Add a new film</DialogTitle>
          <DialogContent>
            <DialogContentText>
             Add new category
            </DialogContentText>
            <TextField
              autoFocus
              fullWidth
              margin="dense"
              id="category"
              value={dialogValue.title}
              onChange={(event) => setDialogValue({ ...dialogValue, title: event.target.value })}
              label="title"
              type="text"
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cancel
            </Button>
            <Button type="submit" color="primary">
              Add
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}
